// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__27Bvw","container":"styles_container__1ovSZ","title":"styles_title__2sePu","wrapper":"styles_wrapper__26LEq","answer":"styles_answer__nkahg"};